import React from "react";
import { Link } from "react-router-dom";
import { Checkbox, message, Input, Form } from "antd";
import LogoWithTitle from "../lt/lt";
import config from '@/config'
import FadeInWhenVisible from "@/components/animations/FadeInWhenVisible";
import { MD5 } from "crypto-js";
import UserService from '@/services/UserService'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebook, faGoogle} from "@fortawesome/free-brands-svg-icons";
import {faPhone} from "@fortawesome/free-solid-svg-icons";

const Register = () => {
    const [form] = Form.useForm();

    function handleRegister(values) {
        const data = {
            username: values.username,
            email: values.email,
            passwordMd5: MD5(values.password).toString()
        }
        UserService.register({data}).then(res => console.log(res))
    }

    return (
        <FadeInWhenVisible>
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-6 lg:px-8">
                <LogoWithTitle
                    src="/img/logo_TinViet2.jpg"
                    alt="Your Company"
                    title="Đăng ký"
                />

                <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-sm">
                    <Form form={form} onFinish={handleRegister} layout="vertical">
                        <Form.Item
                            label={<span className="font-medium">Username</span>}
                            name="username"
                            required
                            validateTrigger={["onBlur"]} // Kiểm tra khi nhập và rời khỏi
                            rules={[
                                { required: true, message: "Vui lòng nhập username !" },
                            ]}
                        >
                            <Input className="p-2" placeholder="Nhập username của bạn" />
                        </Form.Item>
                        <Form.Item
                            label={<span className="font-medium">Email</span>}
                            name="email"
                            required
                            validateTrigger={["onBlur"]} // Kiểm tra khi nhập và rời khỏi
                            rules={[
                                { required: true, message: "Vui lòng nhập email!" },
                                { type: "email", message: "Email không hợp lệ!" },
                            ]}
                        >
                            <Input className="p-2" placeholder="Nhập email của bạn" />
                        </Form.Item>
                        <Form.Item
                            label={<span className="font-medium">Mật khẩu</span>}
                            name="password"
                            required
                            validateTrigger={["onBlur"]}
                            rules={[
                                { required: true, message: "Vui lòng nhập mật khẩu!" },
                                { min: 6, message: "Mật khẩu phải có ít nhất 6 ký tự!" },
                            ]}
                        >
                            <Input.Password className="p-2" placeholder="Nhập mật khẩu" />
                        </Form.Item>
                        <Form.Item
                            label={<span className="font-medium">Nhập lại mật khẩu</span>}
                            name="confirmPassword"
                            dependencies={["password"]}
                            validateTrigger={["onChange", "onBlur"]}
                            rules={[
                                { required: true, message: "Vui lòng nhập lại mật khẩu!" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("password") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Mật khẩu không khớp!"));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password className="p-2" placeholder="Nhập lại mật khẩu" />
                        </Form.Item>
                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md bg-primary p-2 text-base/7 font-semibold text-white shadow-sm hover:bg-primary-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                Đăng ký
                            </button>
                        </div>
                    </Form>

                    <p className="mt-5 text-center text-sm/6 text-gray-500">
                        Đã có tài khoản?{' '}
                        <Link to={config.routes.login} className="font-semibold text-indigo-600 hover:text-indigo-500">
                            Đăng nhập
                        </Link>
                    </p>
                    <p className="mt-5 text-center text-sm/6 text-gray-500">
                        Hoặc đăng nhập với{''}
                    </p>
                    <div className="flex justify-center fa-align-center mt-4">
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faGoogle} className={"text-red-500"} />
                        </Link>
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faFacebook} className={"text-indigo-500"} />
                        </Link>
                        <Link to={"/dang-nhap/sso/google"} className={"px-8 py-4 items-center flex text-3xl font-bold shadow-lg me-2 bg-gray-100 rounded-xl transition-all hover:bg-gray-300"}>
                            <FontAwesomeIcon icon={faPhone} className={"text-green-500"} />
                        </Link>
                    </div>
                </div>
            </div>
        </FadeInWhenVisible>
    )
}

export default Register;